import React, { useState, useEffect } from 'react'
import TabGroup, { Tab } from 'components/common/TabGroup/TabGroup'

import Chat from 'components/set/Chat/Chat'
import Forum from 'components/set/Forum/Forum'
import VideoList from 'components/set/VideoList/VideoList'
import WidgetContainer from 'components/set/WidgetContainer/WidgetContainer'
import { getShow, getIsEnabledAta } from 'redux/slices/liveShow'
import { getCurtainValue } from 'redux/slices/curtain'
import { isSmartTV } from 'utils'
import { useSelector } from 'react-redux'
import { useStyles } from './styles'
import { showHasEnded } from 'utils/show'
import { isMobile } from 'utils'
import { isCurtainClosed } from 'utils/curtain'
import { useAuthenticatedState } from 'libs/web-client/utils/auth0/src'

const InteractionWidget = () => {
    const { isAuthenticated, user } = useAuthenticatedState()
    const show = useSelector(getShow)
    const curtainValue = useSelector(getCurtainValue)
    const isEnabledAta = useSelector(getIsEnabledAta)
    const showVideoTabs = showHasEnded(show)

    const shouldShowLastTab = isMobile() && isCurtainClosed(curtainValue)
    const tabs = [
        {
            key: 'vod',
            component: VideoList,
            label: 'Videos',
            shouldDisplay: showVideoTabs,
        },
        {
            key: 'chat',
            component: Chat,
            props: {
                show,
            },
            label: 'Chat',
            shouldDisplay: true,
        },
        {
            key: 'forum',
            component: Forum,
            label: 'Q&A',
            shouldDisplay: isEnabledAta,
        },
        {
            key: 'info',
            component: WidgetContainer,
            label: 'Info',
            mobileOnly: true,
            shouldDisplay: !showVideoTabs,
        },
    ]

    const visibleTabs = tabs.filter(t => t.shouldDisplay)
    const infoTabIndex = visibleTabs.findIndex(tab => tab.key === 'info')

    const [tabIndex, setTabIndex] = useState(shouldShowLastTab ? infoTabIndex : 0)

    useEffect(() => {
        if (shouldShowLastTab) {
            setTabIndex(infoTabIndex)
        }
    }, [shouldShowLastTab, infoTabIndex])

    const classes = useStyles()
    const currentTab = visibleTabs[tabIndex]

    return (
        <>
            <TabGroup value={tabIndex} onChange={setTabIndex}>
                {visibleTabs.map((t, idx) => (
                    <Tab label={t.label} key={idx} mobileonly={!!t.mobileOnly} />
                ))}
            </TabGroup>
            <div className={!isSmartTV ? classes.interactionWidgetContent : classes.tvInteractionWidgetContent}>
                {<currentTab.component isAuthenticated={isAuthenticated} user={user} {...(currentTab.props || {})} />}
            </div>
        </>
    )
}

export default React.memo(InteractionWidget)
